import {defineSlotRecipe} from '@chakra-ui/react3'

/**
 * recipe for CopyOnly:
 * variants:
 *  - alignment: left | center | right
 */

export default defineSlotRecipe({
    slots: ['root', 'buttonGroup'],
    base: {
        root: {
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
            paddingX: {base: 'spacing-24', s: 'spacing-90'}
        },
        buttonGroup: {paddingTop: {base: 'spacing-8', s: 'spacing-16'}}
    },
    variants: {
        alignment: {
            left: {
                root: {alignItems: 'flex-start'},
                buttonGroup: {justifyContent: 'flex-start'}
            },
            center: {
                root: {alignItems: 'center'},
                buttonGroup: {justifyContent: 'center'}
            }
        },
        spacing: {
            default: {
                root: {
                    paddingTop: {base: 'spacing-64', s: 'spacing-128'},
                    paddingBottom: {base: 'spacing-40', s: 'spacing-128'}
                }
            },
            reduced: {
                root: {paddingTop: 'spacing-40', paddingBottom: 'spacing-40'}
            }
        }
    },
    defaultVariants: {
        alignment: 'left',
        spacing: 'default'
    }
})
